import axios from "../config";
import { getToken, getMobileNumber } from "../../utils/session-utils";

export const getQuestions = (onSuccess, onError) =>
  axios
    .get("/v1/questions", {
      headers: {
        Authorization: getToken(),
        mobileNumber: getMobileNumber()
      }
    })
    .then(res => onSuccess(res.data))
    .catch(err => onError(err.message));
